import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { unlockAccount } from "../../../../api/AuthAPI";
import { Button, Stack, Text, TextInput } from "@mantine/core";

const UA1 = ({ handleNext }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const [errorCode, setErrorCode] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation()
    setLoading(true);
    setErrorCode(false);
    let formData = new FormData(e.target);
    const data = Object.fromEntries(formData);

    unlockAccount(data)
      .then((response) => {
        if (response.data.state) {
          handleNext();
        }
      })
      .catch((error) => {
        if (error.response.data.state_message === "incorrect_code") {
          setErrorCode(true);
          document.getElementById("unlock-code").focus();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Stack component="form" onSubmit={handleSubmit}>
      <Text fz={24}>
        {lang.unlock_account.step_verify.title}
      </Text>
      <Text size="lg">{lang.unlock_account.step_verify.text}</Text>
      <TextInput
        name="code"
        id="unlock-code"
        label={lang.unlock_account.step_verify.code}
        error={errorCode ? lang.errors.helper_texts.incorrectCode : null}
        required
        size="lg"
      />

      <Button size="lg" loading={loading} type="submit" mt={"lg"}>
        {lang.unlock_account.step_verify.button_label}
      </Button>
    </Stack>
  );
};

export default UA1;
